import { render, staticRenderFns } from "./HomeEmpfehlung.vue?vue&type=template&id=091739dd&"
import script from "./HomeEmpfehlung.vue?vue&type=script&lang=js&"
export * from "./HomeEmpfehlung.vue?vue&type=script&lang=js&"
import style0 from "./HomeEmpfehlung.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports